import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react';
import Timesegments from './';

/**
 * Timesegment Dialog.
 * @param {open, onClose, site} props
 */
function TimesegmentDialog(props) {
  const { open, onClose, site } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogContent>
        <Timesegments
          site={site}
          onComplete={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}

export default TimesegmentDialog;
